export function notImplementedWarn(methodName) {
    // tslint:disable-next-line: no-console
    console && console.warn(methodName + ": Method not available in 1DS");
}
var Utils = /** @class */ (function () {
    function Utils() {
    }
    Utils.prototype.stringifyField = function (fieldName, value) {
        // NO OP
        notImplementedWarn("stringifyField");
    };
    Utils.prototype.getMuidHost = function (rootDomain) {
        // TODO: Add when 1DS functionality is available (Task 7393881)
        // NO OP
        notImplementedWarn("getMuidHost");
        return "";
    };
    Utils.prototype.isOfCorrectType = function (type, value) {
        // NO OP
        notImplementedWarn("isOfCorrectType");
        return true;
    };
    Utils.prototype.getOs = function () {
        // NO OP
        notImplementedWarn("getOs");
        return "";
    };
    Utils.prototype.getUserAgent = function () {
        // NO OP
        notImplementedWarn("getUserAgent");
        return "";
    };
    Utils.prototype.extractFieldFromObject = function (obj, fieldName) {
        // NO OP
        notImplementedWarn("extractFieldFromObject");
        return "";
    };
    Utils.prototype.extend = function (obj, obj2, obj3, obj4, obj5) {
        // NO OP
        notImplementedWarn("extend");
    };
    Utils.prototype.isValueAssigned = function (obj) {
        // NO OP
        notImplementedWarn("isValueAssigned");
    };
    Utils.prototype.removeNonObjectsAndInvalidElements = function (obj1, obj2) {
        // NO OP
        notImplementedWarn("removeNonObjectsAndInvalidElements");
    };
    Utils.prototype.dateToISOString = function (date) {
        // NO OP
        notImplementedWarn("dateToISOString");
        return "";
    };
    Utils.prototype.getAppIdWithPrefix = function (appId) {
        // NO OP
        notImplementedWarn("getAppIdWithPrefix");
        return "";
    };
    Utils.prototype.removeInvalidElements = function (obj) {
        // NO OP
        notImplementedWarn("removeInvalidElements");
    };
    Utils.prototype.findClosestByAttribute = function (element, attribute) {
        // NO OP
        notImplementedWarn("findClosestByAttribute");
        return null;
    };
    Utils.prototype.findClosestAnchor = function (element) {
        // NO OP
        notImplementedWarn("findClosestAnchor");
        return null;
    };
    Utils.prototype.returnDomObjectIfjQuery = function (obj) {
        // NO OP
        notImplementedWarn("returnDomObjectIfjQuery");
        return null;
    };
    Utils.prototype.getPerformanceData = function () {
        // NO OP
        notImplementedWarn("getPerformanceData");
    };
    Utils.prototype.bracketIt = function (input) {
        // NO OP
        notImplementedWarn("bracketIt");
        return "";
    };
    Utils.prototype.getPageLoadTime = function () {
        // NO OP
        notImplementedWarn("getPageLoadTime");
        return -1;
    };
    Utils.prototype.isElementTrulyVisible = function (element, viewportRectangle) {
        // NO OP
        notImplementedWarn("isElementTrulyVisible");
        return false;
    };
    Utils.prototype.addPageUnloadEventListener = function (listener) {
        // NO OP
        notImplementedWarn("addPageUnloadEventListener");
        return false;
    };
    Utils.prototype.addEventHandler = function (eventName, callback) {
        // NO OP
        notImplementedWarn("addEventHandler");
        return false;
    };
    Utils.prototype.attachEvent = function (obj, eventNameWithoutOn, handlerRef, useCapture) {
        // NO OP
        notImplementedWarn("attachEvent");
        return false;
    };
    return Utils;
}());
export { Utils };
//# sourceMappingURL=Utils.js.map